import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  computed,
  inject,
  input,
} from '@angular/core';
import {
  BrnDialog,
  BrnDialogClose,
  BrnDialogContent,
  BrnDialogOverlay,
} from '@spartan-ng/brain/dialog';
import { cn } from '../../utils/class.utils';

/** Ancla el `BrnDialog` (estado + apertura/cierre) al elemento host; sus descendientes en el
 * template (trigger, contenido, overlay, close) lo resuelven por inyección de dependencias. */
@Component({
  selector: 'app-dialog',
  standalone: true,
  hostDirectives: [BrnDialog],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-content />`,
})
export class DialogComponent {
  private readonly dialog = inject(BrnDialog, { self: true });

  open(): void {
    this.dialog.open();
  }

  close(result?: unknown): void {
    this.dialog.close(result);
  }
}

@Directive({
  selector: '[appDialogContent]',
  standalone: true,
  hostDirectives: [BrnDialogContent],
})
export class DialogContentDirective {}

@Directive({
  selector: '[appDialogOverlay]',
  standalone: true,
  hostDirectives: [BrnDialogOverlay],
  host: { class: 'fixed inset-0 z-40 bg-heading/50' },
})
export class DialogOverlayDirective {}

@Component({
  selector: 'app-dialog-panel',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'dialog',
    'aria-modal': 'true',
    '[class]': '_computedClass()',
  },
  template: `<ng-content />`,
})
export class DialogPanelComponent {
  // eslint-disable-next-line @angular-eslint/no-input-rename -- lets callers write class="..." directly, merged via cn()
  readonly userClass = input('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    cn(
      'fixed top-1/2 left-1/2 z-50 max-h-[calc(100dvh-2rem)] w-full max-w-lg -translate-x-1/2 overflow-y-auto -translate-y-1/2 rounded-[14px] border border-border bg-surface shadow-lg',
      this.userClass(),
    ),
  );
}

@Directive({
  selector: 'button[appDialogClose]',
  standalone: true,
  hostDirectives: [BrnDialogClose],
})
export class DialogCloseDirective {}
